import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { Button, HStack, Image } from "@chakra-ui/react";
import { signIn } from "next-auth/react";

import Link from "next/link";

type Props = {
  title?: string;
  logo?: string;
};

export const PublicNavbar = ({ title, logo }: Props) => {
  const { status } = useAuthenticatedUser();
  return (
    <HStack
      w="full"
      h="70px"
      justifyContent="space-between"
      py={4}
      px={8}
      bgColor="black.50"
      position="sticky"
      top={0}
      zIndex={10}
    >
      <HStack gap={4}>
        <Link href={`/`}>
          <Image
            src={logo || "/images/logos/clarifayo-with-icon-bg-yellow.svg"}
            h="50px"
            w="250px"
            objectFit={"fill"}
            alt="logo"
          />
        </Link>
      </HStack>
      <HStack>
        {status === "authenticated" ? (
          <Button
            as={"a"}
            fontWeight={500}
            color="black.900"
            variant={"primary"}
            href="/router"
          >
            Login
          </Button>
        ) : (
          <Button
            as={"a"}
            fontWeight={500}
            color="brand.1000"
            variant={"primary"}
            href="/auth/sign-in"
            onClick={(e) => {
              e.preventDefault();
              signIn("auth0", {
                callbackUrl: `${window.location.origin}/router`,
              });
            }}
          >
            Login
          </Button>
        )}
      </HStack>
    </HStack>
  );
};
